import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { RoleRequest } from '.';
import { API_BASE } from '../api-base.token';
import { RoleResponse } from './role-response.model';

const path = 'roles';

@Injectable({
  providedIn: 'root',
})
export class RolesHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.get<RoleResponse[]>(url);
  }

  getById(roleId: string) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${roleId}`);

    return this.httpClient.get<RoleResponse>(url);
  }

  post(deviceRequest: RoleRequest) {
    const url = Location.joinWithSlash(this.apiBase, 'roles');

    return this.httpClient.post<RoleResponse>(url, deviceRequest);
  }

  put(roleId: string, roleRequest: RoleRequest) {
    const url = Location.joinWithSlash(this.apiBase, `roles/${roleId}`);

    return this.httpClient.put<RoleResponse>(url, roleRequest);
  }

  delete(roleId: string) {
    const deleteDeviceUrl = Location.joinWithSlash(
      this.apiBase,
      `roles/${roleId}`
    );

    return this.httpClient.delete(deleteDeviceUrl);
  }

  getWorkspaceRoles(workspaceId: string) {
    const url = Location.joinWithSlash(this.apiBase, `roles/workspace/${workspaceId}`);

    return this.httpClient.get<RoleResponse[]>(url);
  }
}
